import { Component } from '@theme/component';

/**
 * Reveals homepage category cards as they enter the viewport.
 *
 * @extends {Component}
 */
class HomeSectionReveal extends Component {
  #main;
  #sectionListObserver;
  #categoryCardObserver;

  connectedCallback() {
    super.connectedCallback();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const main = document.querySelector('#MainContent');
    if (!(main instanceof HTMLElement)) return;

    this.#main = main;
    this.#categoryCardObserver = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;

          entry.target.setAttribute('data-home-category-card-revealed', '');
          entry.target.removeAttribute('data-home-category-card-pending');
          this.#categoryCardObserver.unobserve(entry.target);
        }
      },
      { rootMargin: '-60px' }
    );

    this.#sectionListObserver = new MutationObserver(() => this.#prepareSections());
    this.#sectionListObserver.observe(main, { childList: true, subtree: true });

    this.#prepareSections();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#sectionListObserver?.disconnect();
    this.#categoryCardObserver?.disconnect();
  }

  #prepareSections() {
    if (!this.#main) return;

    for (const section of this.#main.querySelectorAll('#categories')) {
      if (!(section instanceof HTMLElement)) continue;

      const categoryCards = section.querySelectorAll('.resource-list__item, .resource-list__slide');
      categoryCards.forEach((card, index) => {
        if (
          !(card instanceof HTMLElement) ||
          card.hasAttribute('data-home-category-card-revealed') ||
          card.hasAttribute('data-home-category-card-pending')
        ) {
          return;
        }

        card.style.setProperty('--home-category-reveal-delay', `${index * 80}ms`);
        card.setAttribute('data-home-category-card-pending', '');
        this.#categoryCardObserver.observe(card);
      });
    }
  }
}

if (!customElements.get('home-section-reveal')) {
  customElements.define('home-section-reveal', HomeSectionReveal);
}
